import { z } from 'zod';
// ── Persona reference vocabulary ────────────────────────────────────────────
// Controlled vocabularies for the maintained buyer-persona taxonomy (the
// `personas` reference table). A Company Profile selects personas from this set
// so downstream agents (e.g. the Lead Qualifier) can match `wrong_persona`
// deterministically instead of fuzzy-guessing. New in this work — no persona
// concept existed before. Mirrors the controlled-vocab pattern of
// `EMPLOYEE_BANDS`/`FUNDING_STAGES` in `companies.ts`.
export const PERSONA_DEPARTMENTS = [
    'Revenue Operations',
    'Sales',
    'Marketing',
    'Customer Success',
    'Data & Analytics',
    'Engineering',
    'Product',
    'Operations',
    'Privacy & Legal',
    'Compliance & Risk',
    'Security',
    'Finance',
    'People & HR',
    'Executive',
    'IT',
];
export const PERSONA_SENIORITIES = [
    'IC',
    'Manager',
    'Director',
    'VP',
    'C-Level',
    'Founder',
];
export const PERSONA_BUYER_ROLES = [
    'economic_buyer',
    'champion',
    'influencer',
    'user',
    'blocker',
];
// ── Personas API DTO (snake_case wire) ───────────────────────────────────────
// What the Personas tab + a profile's persona multi-select consume.
export const personaDtoSchema = z.object({
    key: z.string(),
    name: z.string(),
    department: z.string(),
    seniority: z.string(),
    buyer_role: z.string(),
    aliases: z.array(z.string()),
    cares_about: z.array(z.string()),
    // 'seed' (global) | 'custom' (org-authored).
    source: z.string(),
});
export const personasListResponseSchema = z.object({
    personas: z.array(personaDtoSchema),
});
//# sourceMappingURL=personas.js.map